import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LoggerService} from "../../../../core/logger.service";
import {GAService} from "../../../../root/ga/ga.service";
import {PointOfSaleDto, SpecialAttentionHoursDto} from "../../point-of-sale-dto";

@Component({
    selector: 'special-attention-hours',
    templateUrl: './special-attention-hours.component.html',
    providers: []
})
export class SpecialAttentionHoursComponent implements OnInit{

     amountPattern = /^[0-9]+[.]?[0-9]{0,2}$/;

    @Input() dto:PointOfSaleDto;
    @Input() isEditing:boolean = false;
    @Input() errors;
    @Input() errorMessages;
    @Input() data;
    @Input() rangeFrom;
    @Input() rangeTo;
    hours:any=[];
    businessHours:any=[];
    currency:string;
    amount:string;
    validations:any={valid:true, errors:{}};

    constructor(private logger: LoggerService, private translate: TranslateService, private gaService:GAService) {
        logger.info('SpecialAttentionHoursComponent: logger.info()');
    }

    ngOnInit(): void {
        this.setAvailableHours()
        if(this.dto.specialAttentionHours.length){
            this.amount= this.dto.specialAttentionHours[0].amount;
        }
        this.dto.specialAttentionHours.forEach(sah=> this.updateValidHours(sah.rangeFrom,sah.rangeTo));
        this.currency = JSON.parse(localStorage.getItem("company")).currencyCode;
    }

    normalizeHoursView(hour:string):string{
        if(hour=="23:59"){
            return"24:00";
        }
        return hour;
    }

    setAvailableHours(){
        this.dto.businessHours.forEach(bh=>{
            this.businessHours.push({openingHour:this.normalizeHoursView(bh.openingHour),closingHour:this.normalizeHoursView(bh.closingHour)});
        });
        this.hours = this.data.hours.filter(h=> this.businessHours.every(bs =>(h.value>=bs.openingHour && h.value<=bs.closingHour)))
    }

    normalizeHoursDTO(hour:string):string{
        if(hour==="24:00"){
            return"23:59";
        }
        return hour;
    }

    handleClickButton():void{
        this.validations = this.isValid();
        if(this.validations.valid) {
            this.translate.currentLang;
            this.amount = this.amount.toString().replace(",","."); //need no do toString becuase error replace is not a function
            let newSpecialAttentionHour: SpecialAttentionHoursDto = new SpecialAttentionHoursDto(this.amount, this.normalizeHoursDTO(this.rangeFrom), this.normalizeHoursDTO(this.rangeTo));
            this.dto.specialAttentionHours.push(newSpecialAttentionHour);
            this.updateValidHours(this.rangeFrom, this.rangeTo);
            this.gaService.notify("Autos_Sucursales", "Guardar_Horario", ["Click"]);
        }
    }

    removeSpecialAttentionHour(index:number):void{
        this.setAvailableHours();
        this.dto.specialAttentionHours = this.dto.specialAttentionHours.filter(h => h.rangeTo!==this.dto.specialAttentionHours[index].rangeTo && h.rangeFrom!==this.dto.specialAttentionHours[index].rangeFrom);
        this.dto.specialAttentionHours.forEach(sah=> this.updateValidHours(sah.rangeFrom,sah.rangeTo));
        this.updateValidations();
    }

    isOverlapped():boolean {
        let specialHours: SpecialAttentionHoursDto[] = this.dto.specialAttentionHours.filter(h =>
                (this.rangeFrom > h.rangeFrom && this.rangeFrom < h.rangeTo) ||
                (this.rangeTo < h.rangeTo && this.rangeTo > h.rangeFrom) ||
                (this.rangeFrom < h.rangeFrom && this.rangeTo > h.rangeTo));
        return (specialHours.length != 0)
    }

    /*new range must be included in all schedule range when point of sale is open*/
    isRangeIncluded():boolean {
        let acepted = this.businessHours.filter(bh=> this.rangeFrom >= bh.openingHour && this.rangeFrom <= bh.closingHour &&
                                                    this.rangeTo >= bh.openingHour && this.rangeTo <= bh.closingHour)
        return (acepted.length != 0)
    }

    amountChange():void{
        this.amount = this.amount.toString().replace(",",".");
        this.dto.specialAttentionHours.forEach(s=>s.amount=this.amount); //All special hour range must have the same value
        this.updateValidations();
    }

    updateValidations():void{
        let keyErrors = Object.keys(this.validations.errors);
        for (let prop of keyErrors) {
            this.validations.errors[prop] = null;
        }

    }

    eventHandler(event) {
        let ch = String.fromCharCode(event.keyCode);
        let regEx =  new RegExp('^[0-9]|\\.|,$');
        if(!regEx.test(ch)){
            event.preventDefault();
        }
    }

    isValid(){
        let isValid = true;
        let errors = {};

        if(!this.amount){
            isValid = false;
            errors['amount'] = 'common.error.REQUIRED';
        }

        if(!this.amountPattern.test(this.amount)){
            isValid = false;
            errors['amount']= 'ERROR.pointOfSale.specialAttentionHours.amount.format'
        }

        if(!(this.dto.specialAttentionHours.length < 2)){
            isValid = false;
            errors['saveButton'] = 'ERROR.pointOfSale.specialAttentionHours.maxQuantity';
        }

        if(!this.rangeFrom){
            isValid = false;
            errors['rangeFrom'] = 'common.error.REQUIRED';
            return  {valid:isValid, errors:errors};
        }

        if(!this.rangeTo){
            isValid = false;
            errors['rangeTo'] = 'common.error.REQUIRED';
            return  {valid:isValid, errors:errors};
        }

        if(this.rangeTo<=this.rangeFrom){
            isValid = false;
            errors['saveButton'] = 'ERROR.pointOfSale.specialAttentionHours.invalidRange';
        }

        if(this.isOverlapped()){
            isValid = false;
            errors['saveButton'] = 'ERROR.pointOfSale.specialAttentionHours.overlap';
            return  {valid:isValid, errors:errors};
        }

        if(!this.isRangeIncluded()){
            isValid = false;
            errors['saveButton'] = 'ERROR.pointOfSale.specialAttentionHours.outOfBound';
            return  {valid:isValid, errors:errors};
        }

        return  {valid:isValid, errors:errors};
    }

    updateValidHours(rangeFrom:string, rangeTo:string){
        this.hours = this.hours.filter(h=> h.value < rangeFrom || rangeTo < h.value);
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/special-attention-hours/special-attention-hours.component.ts